import React, { useState, useEffect } from 'react';
import { 
    FaPhoneSlash, FaTrash, FaPlus, FaSearch, FaSync, 
    FaUserTimes, FaExclamationTriangle 
} from 'react-icons/fa';
import axiosInstance from '../utils/axiosInstance';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import './css/BlackList.css'; // Mevcut CSS'i kullanıyoruz

const CallMeBlacklistSettings = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const [formData, setFormData] = useState({
        username: '',
        reason: ''
    });

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get('/callmeblacklist/all');
            setList(res.data);
        } catch (err) {
            toast.error("Beni ara listesi yüklenemedi!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchData(); }, []);

    const handleOpenModal = () => {
        setFormData({ username: '', reason: '' });
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosInstance.post('/callmeblacklist/save', formData);
            toast.success("Kullanıcı başarıyla kısıtlandı.");
            setIsModalOpen(false);
            fetchData();
        } catch (err) {
            toast.error(err.response?.data?.message || "Hata oluştu!");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Bu kullanıcının arama engelini kaldırmak istediğinize emin misiniz?")) {
            try {
                await axiosInstance.delete(`/callmeblacklist/${id}`);
                toast.success("Engel kaldırıldı.");
                fetchData();
            } catch (err) {
                toast.error("Silme işlemi başarısız.");
            }
        }
    };

    const filteredList = list.filter(item => 
        item.username.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="data-page-container">
            <header className="header-card">
                <div className="header-info">
                    <h2>Beni Ara Blacklist Yönetimi<span className="count-badge">{list.length}</span></h2>
                    <p>Bu listedeki kullanıcılar "Beni Ara" talebi oluşturamazlar.</p>
                </div>
                <div className="action-group">
                    <button className="btn-modern btn-refresh" onClick={fetchData}>
                        <FaSync className={loading ? 'fa-spin' : ''} />
                    </button>
                    <button className="btn-modern btn-add" onClick={handleOpenModal}>
                        <FaPhoneSlash /> Kullanıcı Engelle
                    </button>
                </div>
            </header>

            <div className="search-bar-container">
                <FaSearch className="search-icon" />
                <input 
                    placeholder="Engelli kullanıcı ara..." 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)} 
                />
            </div>

            <div className="table-container">
                <table className="modern-table">
                    <thead>
                        <tr>
                            <th>KULLANICI</th>
                            <th>ENGEL NEDENİ</th>
                            <th>TARİH</th>
                            <th style={{ textAlign: 'center' }}>İŞLEMLER</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.map((item) => (
                            <tr key={item._id} className="table-row">
                                <td className="user-name">
                                    <FaUserTimes style={{ marginRight: '8px', color: '#e74c3c' }} />
                                    {item.username}
                                </td>
                                <td>
                                    <span className="reason-text">
                                        {item.reason || 'Kural ihlali'}
                                    </span>
                                </td>
                                <td className="date-cell">{dayjs(item.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                                <td className="action-cells">
                                    <button className="btn-action reject" onClick={() => handleDelete(item._id)}>
                                        <FaTrash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <div className="bl-modal-overlay">
                    <div className="bl-modal-wide" style={{ width: '500px' }}>
                        <div className="bl-modal-header">
                            <h3><FaExclamationTriangle color="#e74c3c" /> Yeni Arama Engeli</h3>
                            <button className="bl-close-btn" onClick={() => setIsModalOpen(false)}>&times;</button>
                        </div>
                        <form onSubmit={handleSubmit} className="bl-modal-form">
                            <div className="bl-form-group" style={{ marginBottom: '20px' }}>
                                <label>Kullanıcı Adı</label>
                                <input 
                                    className="bl-input-styled" 
                                    value={formData.username} 
                                    onChange={(e) => setFormData({...formData, username: e.target.value})} 
                                    placeholder="Engellenecek kullanıcı adı..."
                                    required 
                                />
                            </div>
                            <div className="bl-form-group">
                                <label>Engel Nedeni</label>
                                <textarea 
                                    className="bl-input-styled" 
                                    rows="3"
                                    value={formData.reason} 
                                    onChange={(e) => setFormData({...formData, reason: e.target.value})} 
                                    placeholder="Neden kısıtlanıyor?"
                                    style={{ resize: 'none' }}
                                />
                            </div>
                            <div className="bl-modal-footer">
                                <button type="button" className="bl-btn-cancel-new" onClick={() => setIsModalOpen(false)}>İptal</button>
                                <button type="submit" className="bl-btn-submit-new">Engeli Onayla</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CallMeBlacklistSettings;